module.exports = __webpack_public_path__ + "static/media/image.9d9021b5.svg";